import { StudioError } from '#~/error/index.js';
import { CalibrationActionType, calibrate } from './calibrate.js';
import { beginCalibrationAttempt } from './attempt-id.js';
import type { Start } from './types.js';
import { track } from '#~/analytics/index.js';
import { EVENT_CATEGORIES, EVENT_NAMES } from '#~/analytics/constants/index.js';

/**
 * Start device calibration.
 *
 * @param deviceId - Device ID.
 */
export const start: Start = async (deviceId) => {
  try {
    await calibrate(deviceId, CalibrationActionType.CALIBRATION_ACTION_START);

    // TD1 (ENG-4026): synthesize a client-side attempt id when the start
    // command is accepted, and thread it through `calibrate_source` so the
    // terminal `calibration_completed` event can be joined to this attempt.
    const attemptId = beginCalibrationAttempt(deviceId);

    // NOTE: `calibrate_source` fires when the START command is accepted by
    // state-sync — it is NOT a signal that calibration is actually running
    // on the bridge, let alone completed. The canonical terminal signal is
    // `calibration_completed`, emitted from the <Calibration> watchdog.
    track({
      name: EVENT_NAMES.CALIBRATE_SOURCE,
      category: EVENT_CATEGORIES.CALIBRATION,
      properties: {
        deviceId,
        attempt_id: attemptId
      }
    });
  } catch (cause) {
    throw new StudioError('Unable to start device calibration.', { cause });
  }
};
